import { render, staticRenderFns } from "./bulma_actionsprops.vue?vue&type=template&id=7d1bc799"
import script from "./bulma_actionsprops.vue?vue&type=script&lang=js"
export * from "./bulma_actionsprops.vue?vue&type=script&lang=js"
import style0 from "./bulma_actionsprops.vue?vue&type=style&index=0&id=7d1bc799&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports